import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TechnicianDashboardContent from './TechnicianDashboardContent';
import { getGetUserProcesses } from '../../../Core/Service/dashbordService';
import { AppStorage } from '../../../Core/Service/storage-service';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        height: 'calc(100vh - 115px)'
    }
}));

const TechnicianDashboard = (props) => {
    let storedProcessTabId = AppStorage.getDashBoardProcessTabId();
    const classes = useStyles();
    const [value, setValue] = useState(storedProcessTabId || '1');
    const [tabList, setTabList] = useState([]);

    useEffect(() => {
        const fetchProcesses = async () => {
            try {
                let res = await getGetUserProcesses();
                if (res?.data && res.data.length > 0) {
                    setTabList(res.data);
                    const exists = res.data.some((item) => `${item.id}` === `${storedProcessTabId}`);
                    setValue(exists ? `${storedProcessTabId}` : `${res.data[0].id}`);
                } else {
                    setTabList([{ id: 1, name: 'AFTER SALES' }]);
                    setValue('1');
                }
            } catch (err) {
                console.error('Error fetching technician processes:', err);
                setTabList([{ id: 1, name: 'AFTER SALES' }]);
                setValue('1');
            }
        };

        fetchProcesses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        AppStorage.setDashBoardProcessTabId(newValue);
    };

    const hasMultipleTabs = tabList.length > 1;

    return (
        <div className={classes.root}>
            <TabContext value={value}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid #e2e8f0',
                        background: '#ffffff',
                        minHeight: 44,
                        paddingRight: 12
                    }}
                >
                    <TabList
                        onChange={handleChange}
                        aria-label="Technician Dashboard Tabs"
                        indicatorColor="primary"
                        textColor="primary"
                        style={{ minHeight: 40 }}
                    >
                        {tabList.map((t) => (
                            <Tab key={t.id} label={t.name} value={`${t.id}`} style={{ minHeight: 40, fontWeight: 600, fontSize: 13, textTransform: 'none' }} />
                        ))}
                    </TabList>
                    <div id="technician-header-actions" style={{ display: 'flex', alignItems: 'center' }} />
                </div>
                {tabList.map((t) => (
                    <TabPanel
                        key={t.id}
                        value={`${t.id}`}
                        style={{
                            padding: 0,
                            overflow: 'auto',
                            height: 'calc(100vh - 160px)'
                        }}
                        className={'custom-scroll'}
                    >
                        <TechnicianDashboardContent {...props} processID={`${t.id}`} />
                    </TabPanel>
                ))}
            </TabContext>
        </div>
    );
};

export default TechnicianDashboard;
